function Hello() {
    return <div>Hi, I'm Valentin!</div>;
}
export default Hello;